import type { createShopAuthClient } from '~/lib/auth-client'

type SessionRef = ReturnType<ReturnType<typeof createShopAuthClient>['useSession']>

function sessionHasResolved (sessionState: SessionRef['value']) {
  if (!sessionState) {
    return false
  }
  if ((sessionState as { isPending?: boolean }).isPending) {
    return false
  }
  return true
}

// Sync Better Auth session token to Vuex authToken so axios requests use
// betterauth:{token} via the apiKey getter.
//
// Must run inside a component setup (not a plugin) — reuse an existing
// session ref when available.
export function usePosAuthTokenSync (session: SessionRef) {
  const { $store } = useNuxtApp()

  if (!import.meta.client) {
    return
  }

  watch(
    () => session.value,
    (sessionState) => {
      const token = sessionState?.data?.session?.token
      if (token) {
        $store.dispatch('setAuthToken', 'betterauth:' + token)
        return
      }
      // Do not clear authToken while the session is still loading — that
      // would wipe the token set during login/SSR before ClientId requests run.
      // If the user is still marked logged in, keep the token and let keep-alive
      // / 401 recovery handle a genuinely expired session.
      if (sessionHasResolved(sessionState) && sessionState?.data && !sessionState.data.session && !$store.state.user) {
        $store.dispatch('setAuthToken', null)
      }
    },
    { immediate: true }
  )
}
